export default __webpack_public_path__ + "static/resume-cc1eeddf8b9bf77e9d06cbf9e2e54030.pdf";